// React
import React, { Component } from "react";
// Components
import Logo from "./components/Logo";
import UserMenu from "./components/UserMenu";
// constants
import { APP_LOGO } from "../../../../config/constants";

export default class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logo: undefined
    };
  }

  componentDidMount() {
    const appLogo = localStorage.getItem(APP_LOGO);

    this.setState({
      logo: appLogo
    });
  }

  render() {
    const { logo } = this.state;

    return (
      <header id="header">
        <Logo logo={logo} />
        <UserMenu />
      </header>
    );
  }
}
